/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { List, ListItem, ListItemText, Typography  } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

/**
 * region for styles*/
import { menuKeywordStyle } from './style/menuKeywordStyle';

class MenuKeyword extends Component {

    render() {

        const { classes, selectedIndex} = this.props;

        return (
            <List className={classes.paddingTop}>
                <ListItem onClick={this.props.handleSearchAllTerms}>
                    <ListItemText className={classes.cursorPointer} primary={
                        <div className={classes.containerTextAndMark}>
                            {selectedIndex === 1 && (<div className={classes.mark} />)}
                            <Typography className={clsx(selectedIndex === 1 ? classes.isTextChecked : classes.isTextNoChecked)} variant="subtitle1">ALL</Typography >
                        </div>
                    } />
                </ListItem>
                <ListItem onClick={this.props.handleSearchRelatedTerms}>
                    <ListItemText className={classes.cursorPointer} primary={
                        <div className={classes.containerTextAndMark}>
                            {selectedIndex === 2 && (<div className={classes.mark} />)}
                            <Typography className={clsx(selectedIndex === 2 ? classes.isTextChecked : classes.isTextNoChecked)} variant="subtitle1">RELATED TERMS</Typography >
                        </div>
                    } />
                </ListItem>
                <ListItem onClick={this.props.handleSearchUnRelatedTerms}>
                    <ListItemText className={classes.cursorPointer} primary={
                        <div className={classes.containerTextAndMark}>
                            {selectedIndex === 3 && (<div className={classes.mark} />)}
                            <Typography className={clsx(selectedIndex === 3 ? classes.isTextChecked : classes.isTextNoChecked)} variant="subtitle1">UNRELATED TERMS</Typography >
                        </div>
                    } />
                </ListItem>
            </List>
        );
    }
}
MenuKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(menuKeywordStyle)(MenuKeyword);